import React from 'react'
import OurProduct from './OurProduct'
import PersonlizedAssurance from '../components/OurProducts/PersonlizedAssurance'
import WhyCardSlider from '../components/OurProducts/WhyCardSlider'
import CustomerReviews from '../components/AutomobileAssistance/CustomerReviews'

const Products = () => {
  return (
    <>
      <OurProduct />
      <PersonlizedAssurance />
      <WhyCardSlider />

      <CustomerReviews />
    </>
  )
}

export default Products
